/** Default max players for community/scheduled game cards when schedule.maxPlayers is missing */
export const DEFAULT_MAX_PLAYERS = 10

/** Full weekday names indexed by JS day-of-week (0 = Sunday) */
export const DAY_LABELS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']

/** Abbreviated weekday names indexed by JS day-of-week (0 = Sun) */
export const DAY_ABBREVIATIONS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']

/** Selectable per-turn action time options */
export const ACTION_TIME_VALUES = ['20 sec', '30 sec', '60 sec']

/** Selectable blind timer durations: 2 min through 60 min */
export const BLIND_TIME_VALUES = Array.from({ length: 59 }, (_, i) => `${i + 2} min`)

/** Selectable starting chip amounts: 1000 through 50000 in steps of 1000 */
export const STARTING_CHIPS_VALUES = Array.from({ length: 50 }, (_, i) => `${(i + 1) * 1000}`)

/** Minute granularity for time pickers */
export const MINUTE_INTERVAL = 15
